import { Folder } from '../../../domain/models/folder';
import { StorageFolder } from '../models/storageTypes';

export class FolderMapper {
  static toDomain(raw: StorageFolder): Folder {
    return Folder.fromProps({
      id: raw.id,
      name: raw.name,
      color: raw.color,
      icon: raw.icon,
      type: raw.type,
      parentId: raw.parentId,
      order: raw.order,
      createdAt: raw.createdAt,
      updatedAt: raw.updatedAt,
      createdBy: raw.createdBy,
      updatedBy: raw.updatedBy,
    });
  }

  static toStorage(domain: Folder): StorageFolder {
    return domain.toObject();
  }

  static toDomainList(rawList: StorageFolder[]): Folder[] {
    return rawList.map(raw => this.toDomain(raw));
  }

  static toStorageList(domainList: Folder[]): StorageFolder[] {
    return domainList.map(domain => this.toStorage(domain));
  }
}
